module.exports = __webpack_public_path__ + "static/media/hubspotPlugHeader2x.87825988.png";